exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CancelInvite_discription_3dAc {\n  margin-bottom: 24px;\n}\n", ""]);

// exports
exports.locals = {
	"discription": "CancelInvite_discription_3dAc"
};